customElements.define('component-footer', class Footer extends HTMLElement {
  constructor() {
    super();

    const template = document.getElementById('template-footer');
    this.appendChild(template.content.cloneNode(true));
    template.remove();

    this.signUpForm = this.querySelector('#signup-form');
    this.submitButton = this.querySelector('#submit-button');
    this.chatButton = this.querySelector('#footer-chat-button');
    this.formSuccessMessage = this.querySelector('#form-success-message');
    this.formFailMessage = this.querySelector('#form-fail-message');
    this.formEmailFailMessage = this.querySelector('#form-email-fail-message');

    this.cryptoSecret = this.signUpForm.getAttribute('data-crypto-secret');
    this.disServiceKey = this.signUpForm.getAttribute('data-dis-service-key');

    this.submitButton.addEventListener("click", this.submitForm.bind(this));

    // Hide all collapsable menus on mobile
    const clickableHeadings = [...this.getElementsByClassName('footer-collapse-menu')];
    if (window.innerWidth < 1024) {
      this.hideAllMenus(clickableHeadings);
      clickableHeadings.forEach(heading => {
        heading.addEventListener("click", this.toggleMenuVisibility.bind(heading.nextElementSibling));
      });
    } else {
      this.showAllMenues(clickableHeadings);
    }

    // Open chat bubble when user click on chat link
    if(this.chatButton) {
      this.chatButton.addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelector('[data-chat-action="openChat"]').click();
      });
    }

    if(document.querySelector('.footer-contact-info a')) {
      document.querySelector('.footer-contact-info a').addEventListener('click', (e) => {
        if(e.target.innerText.toLowerCase() == 'live chat') {
          e.preventDefault();
          const openChat = document.querySelector('.component-chat-widget .js-chat-widget-btn');
          if(openChat) {
            openChat.click();
          }
        }
      })
    }
  }
  isValidEmail(email) {
    const VALID_EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return VALID_EMAIL_REGEX.test(email);
  }
  async submitForm(e) {
    e.preventDefault();
    const email = this.querySelector('#email-input').value;

    // Identify user on Klaviyo
    window.klaviyoIdentify && window.klaviyoIdentify(email);

    try {
      if (email) {
        const emailLowerCase = (typeof email === 'string') ? email.toLowerCase() : '';
        if (this.isValidEmail(emailLowerCase)) {
          this.cleanErrorMessages();
          this.sendBloomreachConsentEvent(email);
          this.submitEmail(emailLowerCase);
        } else {
          this.showMessage('emailFail');
        }
        await fetch('/contact#signup-form', {
          method: 'POST',
          body:  new FormData(this.signUpForm)
        });
      }
    } catch (error) {
      console.error('Error susbscribing user', e);
      this.showMessage('fail');
    }
  }
  submitEmail(email) {
    this.updateEmailPreference(email).then((res) => {
      const isSuccess = res.ok && res.status === 200;
      if (isSuccess) {
        this.showMessage('success');
        this.hideForm();
        this.trackEmailSubscription(email);
      } else {
        this.showMessage('fail');
      }
    });
  }
  updateEmailPreference(email) {
    const url = window.location.hostname.includes('trythirdlove.com') ? 'https://dis-apis.trythirdlove.com/v0/EmailPreferencesUpdate' : 'https://dis-apis.thirdlove.com/v0/EmailPreferencesUpdate';
    return fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': this.disServiceKey
      },
      method: 'POST',
      body: JSON.stringify({
        "email": email,
        "topic": "Signup Footer"
      })
    });
  }
  hideAllMenus(headings) {
    headings.forEach(heading => {
      heading.nextElementSibling.classList.add('hidden');
    });
  }
  showAllMenues(headings) {
    headings.forEach(heading => {
      heading.nextElementSibling.classList.remove('hidden');
    });
  }
  toggleMenuVisibility() {
    if (this.classList.contains('hidden')) {
      this.classList.remove('hidden');
    } else {
      this.classList.add('hidden');
    }
  }
  showMessage(type) {
    if (type === 'success') {
      this.formSuccessMessage.style.display = 'block';
    } else if (type === 'fail') {
      this.formFailMessage.style.display = 'block';
    } else {
      this.formEmailFailMessage.style.display = 'block';
    }
  }
  cleanErrorMessages() {
    this.formSuccessMessage.style.display = 'none';
    this.formFailMessage.style.display = 'none';
    this.formEmailFailMessage.style.display = 'none';
  }
  hideForm() {
    this.signUpForm.style.display = 'none';
  }
  trackEmailSubscription(email) {
    try {
      const cipherInstance = browserCrypto.createCipher(
        'aes-256-cbc',
        this.cryptoSecret,
      );
      const encryptedEmail = cipherInstance.update(email, 'utf8', 'hex');
      const finalEmailHash = encryptedEmail + cipherInstance.final('hex');

      window.sendGTMData && window.sendGTMData({
        event: 'email_subscribe',
        email: finalEmailHash,
        source: 'footer'
      });
    } catch (err) {
      console.error(err);
    }
  }

  sendBloomreachConsentEvent(emailValue) {
    if (window.exponea && emailValue) {
      // Send consent event to Bloomreach
      window.exponea.track('consent', {
        "email": emailValue,
        "identification": emailValue,
        "identification_type": "email_id",
        "action": "accept",
        "category": "Marketing",
        "event_type": "consent",
        "timestamp": Date.now(),
        "valid_until": "unlimited"
      });
    }
  }
});
